// extracted by mini-css-extract-plugin
var _1 = "RosteringBody__button--rWYRw SchoolGeneral__button--ZIm36";
var _2 = "RosteringBody__download--UFKbu";
var _3 = "RosteringBody__downloadImage--Ua7Vv";
var _4 = "RosteringBody__downloadText--_LACw";
var _5 = "RosteringBody__main--iFYZ6 OfficeGeneral__sectionContent--CCJVl";
var _6 = "RosteringBody__step--oyARz";
var _7 = "RosteringBody__stepDescription--KE66y";
var _8 = "RosteringBody__stepDescriptionText--AWGJh";
var _9 = "RosteringBody__stepHeader--nbQNc";
var _a = "RosteringBody__stepHeaderText--U5ICb";
var _b = "RosteringBody__steps--P5Fhx";
export { _1 as "button", _2 as "download", _3 as "downloadImage", _4 as "downloadText", _5 as "main", _6 as "step", _7 as "stepDescription", _8 as "stepDescriptionText", _9 as "stepHeader", _a as "stepHeaderText", _b as "steps" }
